import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ProductSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const ProductSearch = ({ searchQuery, setSearchQuery }: ProductSearchProps) => {
  return (
    <div className="relative">
      <Input
        type="text"
        placeholder="Rechercher un produit..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-8"
      />
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
    </div>
  );
};